import React from "react";
import { SvgIcon, SvgIconProps } from "@material-ui/core";

export default function ProfileIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.9002 6.7501C8.9002 5.03801 10.2881 3.6501 12.0002 3.6501C13.7123 3.6501 15.1002 5.03801 15.1002 6.7501C15.1002 8.46218 13.7123 9.8501 12.0002 9.8501C10.2881 9.8501 8.9002 8.46218 8.9002 6.7501ZM12.0002 2.3501C9.57014 2.3501 7.6002 4.32004 7.6002 6.7501C7.6002 9.18015 9.57014 11.1501 12.0002 11.1501C14.4302 11.1501 16.4002 9.18015 16.4002 6.7501C16.4002 4.32004 14.4302 2.3501 12.0002 2.3501ZM4.7002 19.5001C4.7002 20.2181 5.28223 20.8001 6.0002 20.8001H18.0002C18.7182 20.8001 19.3002 20.2181 19.3002 19.5001C19.3002 15.4684 16.0319 12.2001 12.0002 12.2001C7.96852 12.2001 4.7002 15.4684 4.7002 19.5001ZM12.0002 13.5001C14.8675 13.5001 17.2651 15.5114 17.859 18.2001C17.9514 18.6187 18.0002 19.0537 18.0002 19.5001H16.7002H7.3002H6.0002C6.0002 19.0537 6.04894 18.6187 6.14141 18.2001C6.73533 15.5114 9.13288 13.5001 12.0002 13.5001Z"
      />
    </SvgIcon>
  );
}
